import { Divider, View, useMediaQuery } from "native-base";
import { COLORS } from "../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

const DividerLine = ({ direction = "vertical", height = "27px", width = "auto" }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  return (
    <>
      {direction === "vertical" ? (
        <Divider
          orientation={direction}
          mx="3"
          width="1px"
          height={height}
          _light={{
            bg: COLORS.SOLID_DIVIDER_COLOR,
          }}
        />
      ) : direction === "horizontal" ? (
        <Divider
          my={1}
          bg={COLORS.NOTIFICATION_DIVIDER_COLOR}
          height="1px"
          width={width}
        />
      ) : (
        <View
          mx={5}
          borderLeftWidth={1}
          borderLeftColor={COLORS.DASHED_DIVIDER_COLOR}
          height={MobileWindow ? "50px" : "62px"}
          width="1px"
          borderStyle={"dashed"}
        ></View>
      )}
    </>
  );
};

export default DividerLine;
